import $ from 'jquery';

if ( $('.mixer-manual-grid-item').length ) {
    $(window).on('load', function () {
        var hash = window.location.hash;
        var hashCategory = hash.replace('#', '');

      //Check if the window has a hash on load and hide the cards that don't have the hash category
        if ( hashCategory.length ) {
            $('.mixer-manual-grid-item').each(function () {
                var card = $(this);
                if ( card.hasClass(hashCategory) || hashCategory == 'all' ) {
                    card.removeClass('hide-mixer-manual');
                } else {
                    card.addClass('hide-mixer-manual');
                }
            });
        }

      //Sorts the main filtering categories
        $('.js-sort a').on('click', function ( e ) {
            e.preventDefault();

            var $this = $(this);
            var category = $this.data('category');

            $this.siblings().removeClass('active');
            $this.addClass('active');
            window.location.hash = category;  //update the hash

          //Foreach card we check if the catagory slug exists in the class attributes, hide it if it doesn't have the category class
            $('.mixer-manual-grid-item').each(function () {
                var card = $(this);

                if ( card.hasClass(category) || category == 'all' ) {
                    card.each(function () {
                        card.removeClass('hide-mixer-manual');
                    });
                } else {
                    card.addClass('hide-mixer-manual');
                }
            });

            $('.js-button').hide();
        });

      //Tag click runs filters and hash changes
        $('.js-tag input').on('click', function () {
            filterEngine();
            hashChange();
        });

      //Clicking an active tag clears the tag, reruns filter and hash functions
        $('.js-tag-active button').on('click', function () {

            current = $(this).val();

            $('.js-tag').find("[value='" + current + "']").prop('checked', false);
            $(this).removeClass('active-tag');

            filterEngine();
            hashChange();
        });

        $('.js-button').on('click', function (e) {
            e.preventDefault();
            $('.mixer-manual-grid-item').removeClass('hide-mixer-manual')
            $('.js-button').hide();
        })
    });
}
